/**
 * Utility for merging class names with Tailwind CSS support
 * Combines clsx for conditional classes with tailwind-merge for deduplication
 */

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names with Tailwind CSS conflict resolution
 * @param {...(string|object|array)} inputs - Class names, objects, or arrays
 * @returns {string} Merged and deduplicated class string
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-primary-500', { 'text-white': isActive })
 * // => 'px-4 py-2 bg-primary-500 text-white' (when isActive is true)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export default cn;
